export interface LanguageTranslations {
  arabic: string
  hebrew: string
  mathematics: string
  english: string
  drawing: string
}
const language_translations: LanguageTranslations = {
  arabic: 'عربي',
  hebrew: 'عبري',
  mathematics: 'حساب',
  english: 'انجليزي',
  drawing: 'رسم',
}
export default language_translations
